export const darkTheme = {
    bg:"#1C1C27",
    bgLight: "#1C1E27",
    primary:"#64e79e",
    text_primary:"#000",
    text_secondary:"#b1b2b3",
    card:"#171721",
    card_light: '#FFF',
    button:"#854CE6",
    white:"#FFFFFF",
    black:"#000000",
    red: "#ef0000",
    green: "#00C853",
    blue: "#0000ff",
}

export const lightTheme = {
    bg:"#FFFFFF",
    bgLight: "#f0f0f0",
    primary:"#000",
    text_primary:"#111111",
    text_secondary:"#48494a",
    card:"#FFFFFF",
    button:"#5c5b5b",
}
